<div id="orAdministrationBuilding">
  <div class="or-content-body">
    <app-form-building-details [isNew]="false" [details$]="buildingDetails$" [success$]='success$'></app-form-building-details>
  </div>
</div>
